<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Plan
    </button>
    <a-modal v-model="visible" title="Add a new plan">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Plan</a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input plan name!' }]}]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
        </a-form-item>
        <a-form-item label="Price">
          <a-input-number
            placeholder="Price"
            v-decorator="['price', {rules: [{ required: true, message: 'Please input plan price!' }]}]"
            :initialValue="1000"
            :min="0"
            :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
            :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
            :width="200"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'AddPlan',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new plan!`,
            onOk: () => {
              this.$http
                .post('/api/plan', {
                  name: values.name,
                  description: values.description,
                  price: values.price,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Plan successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
